import NoData from "assets/svgs/no_data/NoData";
import { fourPlaceHolder } from "modules/utilities/utility";
import React from "react";

function StockDataTable({ isLoading, stocksData }) {
  const header = [
    "Order Id",
    "Varient Name",
    "Quantity",
    "Warehouse Location Code",
    "Channel",
  ];

  return (
    <div>
      <div className="mt-1 shadow rounded">
        <div className="d-flex table-head rounded-top">
          {header?.map((item) => {
            return (
              <span className="p-3 fw-bold text-black flex-1">{item}</span>
            );
          })}
        </div>
        {isLoading ? (
              fourPlaceHolder()
        ) : stocksData && stocksData?.length ? (
          stocksData?.map((customer, index) => {
            return (
              <div
                className={`d-flex table-row border- border-top-0 ${
                  index === stocksData?.length - 1 && `rounded-bottom`
                }`}
              >
                <span className="p-3 flex-1 text-break text-black text-wrap">
                  {customer?.order_display_id}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap">
                  {customer?.variant_name}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap">
                  {customer?.quantity}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap">
                  {customer?.warehouse_location_code}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap">
                  {customer?.channel}
                </span>
              </div>
            );
          })
        ) : (
          <div className="p-3 bg-white rounded-bottom text-center">
            {" "}
            No Data Available <NoData />
          </div>
        )}
      </div>
    </div>
  );
}

export default StockDataTable;
